import { render } from "./CheckboxButton.vue?vue&type=template&id=4074d5c2&scoped=true&ts=true"
import script from "./CheckboxButton.vue?vue&type=script&lang=ts"
export * from "./CheckboxButton.vue?vue&type=script&lang=ts"

import "./CheckboxButton.vue?vue&type=style&index=0&id=4074d5c2&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4074d5c2"]])

export default __exports__